<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">添加</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                             <el-col :span="12" class="item">
                                <el-form-item label="手机号(登录账号)" required prop="phone">
                                    <el-input v-model="addForm.phone"  maxlength="11" placeholder="请输入手机号"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="登录密码" required  prop="password">
                                    <el-input v-model="addForm.password" minlength="6" type="password" placeholder="请输入登录密码" show-password></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="姓名" required prop="name">
                                    <el-input v-model="addForm.name" placeholder="请输入服务人员姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="身份证号" required prop="idCard">
                                    <el-input v-model="addForm.idCard" maxlength="18" placeholder="请输入身份证号"></el-input>
                                </el-form-item>
                            </el-col>

                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import idcardRules from "@/common/idcardRules";

  const validatorIdNumber = (rule, value, callback) => {
  if(value){
    if (idcardRules(value)) {
        callback();
    } else {
        return callback(new Error('请输入正确的证件号'))
    }
  }else{
    callback()
  }

};

    export default {
        name: 'Add',
        data() {
            return {
                loading: false,

                healthCardsFileList:[],
                qualificationFileList:[],
                uploadUrl:this.$shopUrl+'Upload/Imgs',
                uploadUrl1:this.$shopUrl+'Upload/File',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },

                qualificationImageUrl:'',
                qualificationVisible:false,
                healthCardsImageUrl:'',
                healthCardsVisible:false,
                defaultProps: {
                    children: 'listMenuDTO',
                    label: 'name'
                },
                serviceTypeValue:['兼职','专职'],

                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    phone:'',
                    password:'',
                    idCard:'',
                },

                rules:{
                    phone:[
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        {
                            pattern: /^1[3456789]\d{9}$/,
                            message: '请输入正确的手机号'
                        },
                    ],
                    name:[
                        { required: true, message: '请输入商家名称', trigger: 'blur' },
                    ],
                    password:[
                        { required: true, message: '请输入注册密码', trigger: 'blur' },
                    ],
                    idCard:[
                        { required: true,validator: validatorIdNumber, trigger: 'blur' }
                    ],

                },
            }
        },

        methods: {
            init(){
                this.$refs.addForm.resetFields();

            },

            qualificationRemove(file, fileList) {
                console.log(file, fileList);
                this.addForm.qualification = '';
            },
            qualificationSuccess(res, file) {
                console.log(file)
                this.addForm.qualification = this.$imgUrl+res.data.path;
            },
            qualificationPreview(file) {
                this.qualificationImageUrl = file.url;
                this.qualificationVisible = true;
            },
            healthCardsRemove(file, fileList) {
                console.log(file, fileList);
                this.addForm.healthCards = '';
            },
            healthCardsSuccess(res, file) {
                console.log(file)
                this.addForm.healthCards = this.$imgUrl+res.data.path;
            },
            healthCardsPreview(file) {
                this.healthCardsImageUrl = file.url;
                this.healthCardsVisible = true;
            },
            qualificationBefore(file){
                console.log(file.name)
                var name=file.name;
                name=name.slice(-3)
                if(name!='jpg'&&name!='peg'&&name!='png'&&name!='JPG'&&name!='PNG'&&name!='JPEG'){
                    this.$message({type: 'info', message: '请上传jpg/jpeg/png格式的图片'});
                    // this.qualificationFileList=[]
                    return false;
                }
            },
            healthCardsBefore(file){
                console.log(file.name)
                var name=file.name;
                name=name.slice(-3)
                if(name!='jpg'&&name!='peg'&&name!='png'&&name!='JPG'&&name!='PNG'&&name!='JPEG'){
                    this.$message({type: 'info', message: '请上传jpg/jpeg/png格式的图片'});
                    // this.healthCardsFileList=[]
                    return false;
                }
            },


            closeSelf() {
                this.healthCardsFileList=[]
                this.qualificationFileList=[]
                this.$emit("closeAdd");
                this.loading = false;
            },
             handleImgSuccess(res, file) {
               console.log(file)
               this.addForm.img = this.$imgUrl+res.data.path;
            },



            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Serve/AddByBus",
                    data: this.addForm
                }).then((response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            //this.healthCardsFileList=[]
                            //this.qualificationFileList=[]
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    })
            },


        }
    }


</script>
<style lang="scss" scoped>
</style>
